import React from 'react';
import { CogDouble } from '@sharefiledev/icons';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { addBlock } from './blocks';
import { setLogger } from './logger';
import { MastheadSkeleton } from './Masthead/MastheadSkeleton';
import { MastheadWithLogoProps } from './Masthead/MastheadWithLogo';
import { AsyncHelpModal, AsyncTourModal, clientDashboardModals } from './overlays';
import { AsyncBlockDevelopmentPage } from './Pages';
import { TranslatedString } from './utils/TranslatedString';

export function setup(app: PiletApi) {
	setLogger(app.sf.getLogger());

	addBlock(app);

	app.registerModal(
		clientDashboardModals.showHelp,
		({ ...props }) => <AsyncHelpModal {...props} piletApi={app} />,
		{
			modalProps: {
				title: <TranslatedString localizationKey="helpModal.title" />,
				destroyOnClose: true,
				footer: null,
			},
		}
	);

	app.registerModal(
		clientDashboardModals.showTour,
		props => (
			<AsyncTourModal {...props} {...(props.options ?? { allowSwitchToClassic: true })} />
		),
		{
			modalProps: {
				title: <TranslatedString localizationKey="masthead.popup_title" />,
				destroyOnClose: true,
				footer: null,
			},
			allowSwitchToClassic: true,
		}
	);

	const smokeTestCustomers = [
		'pilet-tests.sharefiletest.com',
		'pilet-tests.sharefilestaging.com',
		'pilet-tests.sharefile.com',
	];

	if (
		process.env.NODE_ENV === 'development' ||
		smokeTestCustomers.includes(location.hostname)
	) {
		app.registerPage('/client-app-block-development', () => (
			<AsyncBlockDevelopmentPage piletApi={app} />
		));

		app.sf.registerLeftNavComponent({
			href: '/client-app-block-development',
			title: () => 'Client App Block Dev',
			icon: CogDouble,
			weight: 50,
		});
	}
}

const LazyMastheadWithLogo = React.lazy(() => import('./Masthead/MastheadWithLogo'));
export const AsyncMastheadWithLogo: React.FC<MastheadWithLogoProps> = props => {
	return (
		<React.Suspense fallback={<MastheadSkeleton />}>
			<LazyMastheadWithLogo {...props} />
		</React.Suspense>
	);
};
